import React, { useState } from 'react'
import {Card, CardBody, Spinner} from "reactstrap";
import Select from "react-select"
import TradingCard from "../Components/TradingCard";
import MetamaskLogo from "../assets/images/metamask.png";

const SortItems = [
  {
    label: 'Created',
    value: 'Created'
  },
  {
    label: 'Listed',
    value: 'Listed'
  },
  {
    label: 'Price',
    value: 'Price'
  },
  {
    label: 'Purchased',
    value: 'Purchased'
  }
]

const SortDirection = [
  {
    label: 'Oldest first',
    value: 'Oldest first'
  },
  {
    label: 'Newest first',
    value: 'Newest first'
  }
]

const Collectibles = (props) => {
  const { items, loading } = props;
  const [selectedSortItem, setSelectedSortItem] = useState(SortItems[0]);
  const [selectedSortDirection, setSelectedSortDirection] = useState(SortDirection[0]);

  return (
    <React.Fragment>
      <div className="content trading-page">
        <Card>
          <CardBody>
            <div className="header">
              <div className="search">
                <div className="search-input">
                  <input id="searchInput" type="text" className="form-control" onKeyPress={() => {}} />
                  <span id="searchSpan" className="bx bx-search"/>
                </div>
              </div>
              <div className="sort-by">
                <span>Sort by:</span>
                <div className="sort-select">
                  <Select
                    value={selectedSortItem}
                    onChange={(item) => setSelectedSortItem(item)}
                    options={SortItems}
                    classNamePrefix="select2-selection"
                  />
                </div>
                <div className="sort-select">
                  <Select
                    value={selectedSortDirection}
                    onChange={(item) => setSelectedSortDirection(item)}
                    options={SortDirection}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </div>
            </div>
            {
              loading && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
                  <Spinner size="lg" color="primary" />
                </div>
              )
            }
            {loading || items.length
              ? (
                <div className="card-list">
                  {
                    !loading && items.map((item, index) => (
                      <TradingCard data={item} key={index} sell={true} />
                    ))
                  }
                </div>
              ) : (
                <div className="d-flex flex-column text-center justify-content-center align-items-center py-5">
                  <div className="metamask_logo">
                    <img src={MetamaskLogo} alt="metamask" style={{ width: 150 }} />
                  </div>
                  <h1 className="mt-4">No NFT Token</h1>
                </div>
              )}
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default Collectibles
